export enum KnowEdmTableData {
  Country = 'locCountry',
  Field = 'projectName',
  Site = 'siteName',
  Well = 'well_commonName',
  Text = 'text',
  Wellbore = 'wellboreName',
  Design = 'name',
  WellConfiguration = 'wellConfiguration',
  WellStatus = 'wellStatus',
  DrillingUnit = 'drillingUnit',
  WaterDepth = 'waterDepth',
  DrillFloorHeightAirgap = 'airGap',
  WellheadDepth = 'wellheadDepth',
  GroundElevation = 'groundElevation',
}
